/** Customer Management URL prefix, e.g. /customers/directory. */
export const CUSTOMERS_BASE = '/customers';

export const customerPaths = {
  /** Default landing — full directory. */
  directory: `${CUSTOMERS_BASE}/directory`,
  create: `${CUSTOMERS_BASE}/directory/create`,
  /** Profile / edit use the customer id as a route param. */
  profile: (id: string) => `${CUSTOMERS_BASE}/directory/${id}`,
  edit: (id: string) => `${CUSTOMERS_BASE}/directory/${id}/edit`,

  // V2 — groups
  groups: `${CUSTOMERS_BASE}/groups`,
  groupCreate: `${CUSTOMERS_BASE}/groups/create`,
  group: (id: string) => `${CUSTOMERS_BASE}/groups/${id}`,
  groupEdit: (id: string) => `${CUSTOMERS_BASE}/groups/${id}/edit`,

  // V2 — segments
  segments: `${CUSTOMERS_BASE}/segments`,
  segmentCreate: `${CUSTOMERS_BASE}/segments/create`,
  segment: (id: string) => `${CUSTOMERS_BASE}/segments/${id}`,
  segmentEdit: (id: string) => `${CUSTOMERS_BASE}/segments/${id}/edit`,
} as const;

/** Route templates registered in App.tsx (param form). */
export const customerRouteTemplates = {
  directory: customerPaths.directory,
  create: customerPaths.create,
  profile: `${CUSTOMERS_BASE}/directory/:id`,
  edit: `${CUSTOMERS_BASE}/directory/:id/edit`,
  groups: customerPaths.groups,
  groupCreate: customerPaths.groupCreate,
  group: `${CUSTOMERS_BASE}/groups/:id`,
  groupEdit: `${CUSTOMERS_BASE}/groups/:id/edit`,
  segments: customerPaths.segments,
  segmentCreate: customerPaths.segmentCreate,
  segment: `${CUSTOMERS_BASE}/segments/:id`,
  segmentEdit: `${CUSTOMERS_BASE}/segments/:id/edit`,
} as const;

/** Routes owned by other modules that Customers links out to. */
export const externalPaths = {
  campaigns: '/campaigns/list',
  campaignReport: (id: string) => `/campaigns/${id}/report`,
} as const;
